import { getCurrentViewersRef, getViewerCount } from "./live-ticker";

(function () {
  // handle max capacity redirects
  if (location.href.includes("?maxCapacity")) {
    alert("The room you were trying to view has reached its maximum capacity. Please try again later.");
  }
  
  // escape hatch
  if (!WP.capacity || !WP.capacity.limitParticipants) return;

  const database = firebase.database(),
    { envKey, pageID } = WP,
    currentViewersRef = getCurrentViewersRef(database, envKey, pageID);

  // current viewers
  currentViewersRef.on("value", (snapshot) => {
    const data = snapshot.val() || {},
      viewerCount = getViewerCount(data);
    
    // check if room is at capacity
    if (isAtCapacity(WP.capacity.maxCapacity, viewerCount)) {
      handleAtCapacity(WP.capacity.redirect);
    }
  });
})();

/**
 * Check if room is at or above max capacity
 * @param {int} max
 * @param {int} current
 * @returns {bool}
 */
 export function isAtCapacity(max, current) {
  if (current > parseInt(max)) return true;

  return false;
}

/**
 * Handle browser behavior when room is at capacity
 * @param {string} redirect - the url a user should be redirected to
 * @returns {bool}
 */
 export function handleAtCapacity(redirect) {
   location.href = redirect + '?maxCapacity';
}